import React, { useState } from 'react';
import MovingInStepOneUi from '../../../components/user-interfaces/moving-in/moving-in-step-one/moving-in-step-one.ui';
import { getAddressGouv } from '../../../services/address.service';
import { showAxiosMessageError } from '../../../services/error-message.service';
import { useSnackbars } from '../../../hooks/snackbar.hook';
import { AddressGouvFeaturesPropertiesFormDto } from '../../../services/dtos/form/address-gouv-features-properties-form.dto';
import { AddressMoveInDto } from '../../../services/dtos/address-move-in.dto';
import { getAddress } from '../../../services/requests.service';
import { MovingInFinishDto } from '../../../services/dtos/moving-in-finish.dto';
import { useNavigate } from 'react-router-dom';

/**
 * Page de étape une d'emménagement
 * @constructor
 */
export default function MovingInStepOnePage() {
    //Déclaration de la navigation
    const navigate = useNavigate();
    //Snackbar
    const showMessage = useSnackbars();
    //UseState
    const [addressesGouv, setAddressesGouv] = useState<AddressGouvFeaturesPropertiesFormDto[]>([]);
    const [showManualAddress, setShowManualAddress] = useState<boolean>(false);
    const [validFormAddress, setValidFormAddress] = useState<boolean>(false);
    const [addresses, setAddresses] = useState<AddressMoveInDto[] | undefined>();
    const [manualFormData, setManualFormData] = useState<any>(null);

    // Handle qui permet de gérer les appels sur Gouv api
    const handleSearchAddress = (event: object, value: string, reason: string) => {
        const minSizeSearch = 3;
        // Si la reason et input et qu'il y a au moins 3 caractères
        // On lance la recherche sinon on ne fait rien
        if (reason === 'input' && value?.trimEnd().length >= minSizeSearch) {
            getAddressGouv(value)
                .then(result => {
                    if (result) {
                        setAddressesGouv(result.features.map(feature => feature.properties));
                    }
                })
                .catch(error => {
                    //Affichage du message d'erreur si la request ne récupère rien
                    console.error('Erreur lors de la récupération du contenu de la page');
                    showAxiosMessageError(error, showMessage);
                });
        }
    };

    // Handle qui permet d'afficher ou non le formulaire d'adresse
    const handleChangeShowManualAddress = () => {
        setShowManualAddress(!showManualAddress);
    };

    // Handle qui permet d'afficher ou non le formulaire d'adresse
    const handleSumbitFormAddress = (form: any) => {
        setValidFormAddress(true);
        // Sauvegarder les données du formulaire manuel pour les transmettre à l'étape 3
        if (showManualAddress) {
            setManualFormData(form);
        }
        //On recherche soit avec le code insee soit via l'adresse remplie manuellement
        getAddress(
            !showManualAddress ? form.address?.citycode : null,
            !showManualAddress ? form.address?.housenumber : form.numeroRue,
            !showManualAddress ? form.address?.street : form.rue,
            !showManualAddress ? form.address?.postcode : form.codePostal,
            !showManualAddress ? form.address?.city : form.ville
        )
            .then(result => {
                //Adresses à afficher
                setAddresses(result);
            })
            .catch(error => {
                //Affichage du message d'erreur si la request ne récupère rien
                console.error('Erreur lors de la récupération du contenu de la page');
                showAxiosMessageError(error, showMessage);
            })
            .finally(() => {
                setValidFormAddress(false);
            });
    };

    const handleGoStepTwo = (address: AddressMoveInDto) => {
        const data: MovingInFinishDto = {
            address: {
                ...address,
                // Ajouter les données de complément saisies manuellement si disponibles
                complement:
                    showManualAddress && manualFormData
                        ? {
                              numeroRue: manualFormData.complement?.numeroRue || '',
                              rue: manualFormData.complement?.rue || '',
                              batiment: manualFormData.complement?.batiment || '',
                              etage: manualFormData.complement?.etage || '',
                              appartement: manualFormData.complement?.appartement || '',
                              escalier: manualFormData.complement?.escalier || '',
                              ville: manualFormData.complement?.ville || '',
                          }
                        : undefined,
            },
        };
        //Infos j'emmenage dans le local storage
        localStorage.setItem('movingInFinish', JSON.stringify(data));
        // Retour à la page d'accueil
        navigate('/j-emmenage/etape-deux');
    };

    // Appel de l'interface, qui contiendra le form
    return (
        <MovingInStepOneUi
            addressesGouv={addressesGouv}
            addresses={addresses}
            handleSearchAddress={handleSearchAddress}
            handleChangeShowManualAddress={handleChangeShowManualAddress}
            showManualAddress={showManualAddress}
            validFormAddress={validFormAddress}
            handleSumbitFormAddress={handleSumbitFormAddress}
            handleGoStepTwo={handleGoStepTwo}
        />
    );
}
